//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const offsetsSlice = createSlice({
    name: 'offsetsSlc',
    initialState: {value: {
            myProductId: null, myGuildId: null, myR2m: null, myCdpId: null,
                updateOffsetsGrid: false, offsetsGridState: true, refreshOffsetsGrid: false}},
    reducers:
        // {
        //     changeOffsets: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeOffsets: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const {changeOffsets} = offsetsSlice.actions;

export default  offsetsSlice.reducer ;
